import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function BlogDetailPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api
      .get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div data-testid="blog-detail-page" className="min-h-screen bg-[#ffffff] text-[#0a0a0a]">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 numeric text-xs uppercase tracking-widest text-black/50 hover:text-[#0a0a0a]"
          >
            <ArrowLeft size={14} /> All stories
          </Link>

          {notFound && (
            <div className="mt-20 text-center">
              <h1 className="font-display text-4xl text-[#0a0a0a]">Post not found.</h1>
              <Link to="/blog" className="btn-secondary mt-8 inline-flex">Back to stories</Link>
            </div>
          )}

          {post && (
            <article className="mt-10">
              {post.agent_revenue && (
                <div className="numeric text-xs text-[#121275] uppercase tracking-widest mb-4">
                  {post.agent_revenue}
                </div>
              )}
              <h1
                data-testid="blog-detail-title"
                className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#0a0a0a]"
              >
                {post.title}
              </h1>
              <div className="mt-6 numeric text-xs text-black/40 uppercase tracking-widest">
                {post.author} ·{" "}
                {new Date(post.created_at).toLocaleDateString("en-US", {
                  month: "long", day: "numeric", year: "numeric",
                })}
              </div>

              {post.cover_image && (
                <div
                  className="mt-12 aspect-[16/9] bg-cover bg-center border border-black/10"
                  style={{ backgroundImage: `url(${post.cover_image})` }}
                />
              )}

              <div className="mt-12 prose prose-invert max-w-none text-black/80 font-light leading-relaxed text-lg space-y-6">
                {post.content.split("\n\n").map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
              </div>

              <div className="mt-20 pt-10 border-t border-black/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
                <div>
                  <div className="overline mb-2">Ready to write your story?</div>
                  <h3 className="font-display text-2xl text-[#0a0a0a] font-light">
                    Apply to Sold By 1st Choice in 3 minutes.
                  </h3>
                </div>
                <Link to="/apply" className="btn-primary group">
                  Apply Now <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </article>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
